<template>
    <div>
        <!-- Fillpattern -->
        <div
            v-if="hasPolygonGeometry && showSvgStyler"
            class="form-inline align-items-baseline"
        >
            <label class="style-label-md">{{ $t('labelPolygonFill') }}</label>
            <svg-styler
                :settings="localSettings"
                @update="$_updateSvgSettings($event)"
            ></svg-styler>
        </div>
        <!-- Color -->
        <div class="form-inline style-item">
            <label :for="`lineFillColorInput${name}`" class="style-label-md"
                >{{ $t('dashboard.styling.color') }}</label
            >
            <div class="form-group">
                <div class="input-group">
                    <div class="row">
                        <div class="col">
                            <color-picker
                                :id="`lineFillColorInput${name}`"
                                :name="`lineFillColorInput${name}`"
                                v-model="localSettings.fillColor"
                            ></color-picker>
                        </div>
                    </div>
                    <div v-if="showSaveDefaultButton" class="col .offset-md-4">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            @click="$_saveAsDefault()"
                        >
                            {{ $t('saveDefaultStyleButton') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Randkleur -->
        <div
            v-if="hasPointGeometry || hasPolygonGeometry"
            class="form-inline style-item"
        >
            <label :for="`lineStrokeColorInput${name}`" class="style-label-md"
                >Randkleur</label
            >
            <div class="form-group">
                <div class="input-group">
                    <color-picker
                        :id="`lineStrokeColorInput${name}`"
                        :name="`lineStrokeColorInput${name}`"
                        required
                        v-model="localSettings.strokeColor"
                    ></color-picker>
                </div>
            </div>
        </div>
        <!-- Lijn dikte -->
        <div class="form-inline style-item">
            <div class="form-group">
                <label :for="`lineStrokeWidthsl${name}`" class="style-label-md"
                    >Lijndikte</label
                >
                <b-form-select
                    :id="`lineStrokeWidthsl${name}`"
                    v-model="localSettings.strokeWidth"
                    @input="$emit('update:strokeWidth', $event)"
                    :options="
                        $_convertToValueTextPair(
                            this.layerStyleConst.stroke_width
                        )
                    "
                >
                </b-form-select>
            </div>
        </div>
        <!-- Punt grootte -->
        <div
            v-if="hasPointGeometry && !isIconSelected"
            class="form-inline style-item"
        >
            <div class="form-group">
                <label for="`linePointSizesl${name}`" class="style-label-md"
                    >Stip radius</label
                >
                <b-form-select
                    :id="`linePointSizesl${name}`"
                    class="form-control input-sm"
                    v-model="localSettings.pointSize"
                    @input="$emit('update:pointSize', $event)"
                    :options="
                        $_convertToValueTextPair(
                            this.layerStyleConst.point_radius
                        )
                    "
                >
                </b-form-select>
            </div>
        </div>
    </div>
</template>

<script>
    import { convertToValueTextPair } from '../../../services/utilities';
    import { LAYER_STYLE, FEEDBACKS_GEOMETRY_TYPE_CODES } from '../../../constants';
    import ColorPicker from '../../../components/ColorPicker.vue';
    import SvgStyler from '../../../components/BaseComponents/SvgStyler.vue';
    import modalMixin from '../../Mixins/ModalMixin.vue';

    export default {
        mixins: [modalMixin],
        components: {
            'color-picker': ColorPicker,
            'svg-styler': SvgStyler
        },

        props: {
            props: { settings: { type: Object, required: true } },
            name: { type: String, required: false, default: '' },
            geometryTypeArray: { type: Array, required: false, default: () => [] },
            isIconSelected: { type: Boolean, required: false, default: false },
            settings: { type: Object, required: true },
            showSvgStyler: { type: Boolean, required: false, default: false },
            showSaveDefaultButton: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        data() {
            return {
                layerStyleConst: LAYER_STYLE,
                localSettings: null
            };
        },

        computed: {
            hasPointGeometry() {
                return this.geometryTypeArray.includes(
                    FEEDBACKS_GEOMETRY_TYPE_CODES.POINT
                );
            },
            hasPolygonGeometry() {
                return this.geometryTypeArray.includes(
                    FEEDBACKS_GEOMETRY_TYPE_CODES.POLYGON
                );
            }
        },

        methods: {
            $_convertToValueTextPair(inputArray, key, value) {
                return convertToValueTextPair(inputArray, key, value);
            },
            $_updateSvgSettings(event) {
                this.localSettings = event;
            },
            $_saveAsDefault() {
                const data = { message: this.$t('saveDefaultStyleConfirmation') };
                this.msgBoxConfirm(data).then((confirmed) => {
                    if (confirmed) {
                        let settingName = 'fillColor';
                        settingName = settingName.concat(this.name.split('_')[1]);
                        this.$store.dispatch('useApiData', {
                            name: 'SaveOrganizationSetting',
                            data: {
                                name: settingName,
                                value: this.localSettings.fillColor
                            }
                        });

                        settingName = 'strokeColor';
                        settingName = settingName.concat(this.name.split('_')[1]);
                        this.$store.dispatch('useApiData', {
                            name: 'SaveOrganizationSetting',
                            data: {
                                name: settingName,
                                value: this.localSettings.strokeColor
                            }
                        });
                    }
                });
            }
        },
        watch: {
            settings: {
                handler: function (newVal) {
                    this.localSettings = JSON.parse(JSON.stringify(newVal));

                    if (!newVal.fillColor) {
                        this.localSettings.fillColor = 'rgba(00,00,00,1)';
                    }

                    if (!newVal.strokeColor) {
                        this.localSettings.strokeColor = 'rgba(00,00,00,1)';
                    }

                    if (!newVal.strokeWidth) {
                        this.localSettings.strokeWidth = 1;
                    }

                    if (!newVal.pointSize) {
                        this.localSettings.pointSize = 1;
                    }
                },
                deep: true,
                immediate: true
            },
            localSettings: {
                handler: function (newVal, oldVal) {
                    if (JSON.stringify(newVal) === JSON.stringify(this.settings)) {
                        return;
                    }
                    this.$emit('update', newVal);
                },
                deep: true
            }
        }
    };
</script>
